
<script context="module">
    import Layout from '@/Layouts/Main.svelte';
    export const layout = Layout;
  </script>

  <script>
  import { inertia } from '@inertiajs/inertia-svelte';

  </script>
  <svelte:head>
    <title>Mur&amp;Partners | Ofertas de empleo</title>
  </svelte:head>

  <div class="py-32 lg:py-40">
    <div class="container min-h-[50%]">
      <div class="text-center">
        <div class="mb-6">
          <h1 class="text-6xl font-semibold">
            Gracias
          </h1>
        </div>
        <div class="text-xl">
          Tu solicitud ha sido enviada correctamente.
        </div>
      </div>
    </div>
  </div>
